import {
  FETCH_BY_ID_DESK_ERROR,
  FETCH_BY_ID_DESK_LOADING,
  FETCH_BY_ID_DESK_SUCCESS,
  FETCH_DESK_FAILURE,
  FETCH_DESK_LOADING,
  FETCH_DESK_SUCCESS,
  FETCH_ROOMS_ERROR,
  FETCH_ROOMS_LOADING,
  FETCH_ROOMS_SUCCESS,
  UPDATE_DESK_FAILURE,
  UPDATE_DESK_LOADING,
  UPDATE_DESK_SUCCESS
} from '../Types/deskType';
import api from '../config/api';

const API_WP = process.env.REACT_APP_API_URL;
export const getDesks = () => {
  return dispatch => {
    dispatch({
      type: FETCH_DESK_LOADING
    });
    api
      .get(`${API_WP}Desk`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_DESK_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_DESK_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const getDeskByID = id => {
  return dispatch => {
    dispatch({
      type: FETCH_BY_ID_DESK_LOADING
    });
    api
      .get(`${API_WP}Desk/search/${id}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_BY_ID_DESK_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_BY_ID_DESK_ERROR,
          payload: errorMsg
        });
      });
  };
};

export const updateDesk = (id, data) => {
  return dispatch => {
    dispatch({ type: UPDATE_DESK_LOADING });
    api
      .put(`${API_WP}Desk/update/${id}`, data)
      .then(response => {
        dispatch({
          type: UPDATE_DESK_SUCCESS,
          payload: response.data.data
        });

        dispatch(getDesks());
      })
      .catch(error => {
        dispatch({
          type: UPDATE_DESK_FAILURE,
          payload: error.message
        });
      });
  };
};

export const updateAvailibility = (id, status) => {
  return api
    .put(process.env.REACT_APP_API_URL + `availability/update`, {
      id: id,
      status: status
    })
    .then(response => {
      return response.data.message;
    })
    .catch(error => {
      const errorPayload = {};
      errorPayload['message'] = error.response.data.message;
      errorPayload['status'] = error.response.status;
      // dispatch(updateDeskError(errorPayload));
    });
};

export const getDesksByFloor = id => {
  return dispatch => {
    dispatch({
      type: FETCH_DESK_LOADING
    });
    api
      .get(`${API_WP}Desk/floor/${id}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_DESK_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_DESK_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const updateDesks = (data, floor) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: FETCH_DESK_LOADING
      });

      api
        .put(`${API_WP}Desk/update`, data)
        .then(() => {
          dispatch(getDesksByFloor(floor));
          resolve({ status: 200 });
        })
        .catch(error => {
          const errorPayload = {};
          errorPayload['message'] = error.response.data.message;
          errorPayload['status'] = error.response.status;
          dispatch({
            type: UPDATE_DESK_FAILURE,
            payload: errorPayload
          });
          reject(errorPayload);
        });
    });
  };
};

export const fetchRooms = id => {
  return dispatch => {
    dispatch({
      type: FETCH_ROOMS_LOADING
    });
    api
      .get(`${API_WP}Desk/rooms?floor=${id}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_ROOMS_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_ROOMS_ERROR,
          payload: errorMsg
        });
      });
  };
};
